import {
  redux_getAllLeads,
  redux_getLead,
  redux_updateLead,
  redux_createLead,
  redux_leadActionStarts,
  redux_leadActionErrors,
  redux_resetLeadErrors,
} from '../../core/data/redux/modules/lead/actions';

import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

export const getAllLeads = () => async (dispatch: Dispatch) => {
  dispatch(redux_leadActionStarts());
  try {
    const response = await makeApiRequest(`/leads/get-all`);
    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_leadActionErrors(responseDto.error));
      } else {
        dispatch(redux_getAllLeads(responseDto.data));
      }
  } catch (error) {
    dispatch(redux_leadActionErrors((error as any)?.message || 'Error fetching leads',));
  }
};

export const createLead = (leadData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_leadActionStarts());
  try {
    const response = await makeApiRequest(`/leads/add`, {
      method: 'POST',
      body: JSON.stringify(leadData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_leadActionErrors(responseDto.error));
      } else {
        dispatch(redux_createLead(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_leadActionErrors((error as any)?.message || 'Error creating lead',));
  }
};

export const updateLead = (id: string, leadData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_leadActionStarts());
  try {
    const response = await makeApiRequest(`/leads/update/${id}`, {
      method: 'PUT',
      body: JSON.stringify(leadData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_leadActionErrors(responseDto.error));
      } else {
        dispatch(redux_updateLead(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_leadActionErrors((error as any)?.message || 'Error updating lead',));
  }
};

export const deleteLead = (id: string) => async (dispatch: Dispatch) => {
  dispatch(redux_leadActionStarts());
  try {
    const response = await makeApiRequest(`/leads/delete/${id}`, {
      method: 'DELETE',
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_leadActionErrors(responseDto.error));
      } 
  } catch (error) {
    dispatch(redux_leadActionErrors((error as any)?.message || 'Error deleting lead',));
  }
};
